// App.js
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom"; // Import BrowserRouter
import ToastProvider from "./components/shared/ToastManager";
import LoadingBar from "react-top-loading-bar";
import { useSelector } from "react-redux";
import { lazy, Suspense, useEffect, useRef } from "react";
import "./utils/sockets/socket"; // 🔥 Load socket connection globally
import { socket, getStoredUserId } from "./utils/sockets/socket";
import { ModalProvider } from "hooks/Modal";
import { ServerErrorProvider } from "./contexts/ServerErrorContext";
import ServerError from "./components/shared/ServerError";
import RouteTitleHandler from "./components/shared/RouteTitleHandler";

const AllRoutes = lazy(() => import('./navigation/AllRoutes'));

// require('dotenv').config()

function App() {
  const { loading } = useSelector((state) => state.app);

  const loadingBarRef = useRef(null);

  useEffect(() => {
    const uid = getStoredUserId();
    if (uid) socket.emit("registerUser", uid);
    if (loading) {
      loadingBarRef.current.continuousStart();
    } else {
      loadingBarRef.current.complete();
    }
  }, [loading]);

  return (
    <div className="App">
      <ServerErrorProvider>
        <ToastProvider>
          <LoadingBar color="#FFD700" height={4} ref={loadingBarRef} />
          <ServerError />
          <Router>
            <RouteTitleHandler />
            <ModalProvider>
              <Suspense
                fallback={<div className="text-center p-10">Loading...</div>}
              >
                <AllRoutes /> {/* All the routes will be handled here */}
              </Suspense>
            </ModalProvider>
          </Router>
        </ToastProvider>
      </ServerErrorProvider>
    </div>
  );
}

export default App;



